export function StatusPill({ status }: { status: string }) {
  const label = status.replace(/_/g, " ");
  return <span className={`pill pill-${status}`} data-testid="status-pill">{label}</span>;
}
